import { render, staticRenderFns } from "./Shared.vue?vue&type=template&id=53b9825d"
import script from "./Shared.vue?vue&type=script&lang=js"
export * from "./Shared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports